export default __webpack_public_path__ + "static/media/people5.ece6c098.png";